export function uniqueFilter(value, index, self) {
  return self.indexOf(value) === index;
}

export function notNullFilter(value, index, self) {
  return value !== 'null';
}
